import { AbstractApi, ApiBaseResponse } from '../../../common/api'
import { Permission } from '../types/permission.types'

class PermissionsApi extends AbstractApi {
  protected url = '/permission'

  public async getPermissions(): Promise<ApiBaseResponse<Permission[]>> {
    const { data: response } = await this.get<ApiBaseResponse<Permission[]>>(this.url)

    return response
  }
}

export const permissionsApi = new PermissionsApi()
